import { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Slider from "react-slick";
import { Modal, Button } from "react-bootstrap";
import { addData } from "../Servicescalls";
import { imgUrl } from "../Baseurls";
import { ToastContainer, toast } from "react-toastify";

const Home = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [openIndex, setOpenIndex] = useState(null); // Faqa
  const [about, setAbout] = useState([]); // ABOUT
  const [testimonals, setTestimonals] = useState([]); // TESTIMONIALS
  const [faqs, setfaqs] = useState([]); // FAQS
  const [contact, setcontact] = useState([]); // CONTACT
  const [mediaIcons, setmediaIcons] = useState([]); //  email and number
  const [homeBanners, sethomeBanners] = useState([]); // Home BANNERS
  const [plans, setplans] = useState([]); // PLANS
  const [isLoading, setIsLoading] = useState(true);

  // get all
  const getAllSections = async () => {
    const resonse = await addData("getallmodules");
    var _data = resonse;
    setAbout(_data.data.aboutus[0]);
    setTestimonals(_data.data.testimonis);
    setfaqs(_data.data.faqs);
    setmediaIcons(_data.data.contactus[0]);
    sethomeBanners(_data.data.banners[0]);
    setplans(_data.data.plans);
  };

  useEffect(() => {
    getAllSections();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setcontact((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleVideoLoad = () => {
    setIsLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const bodydata = {
      name: contact.name,
      email: contact.email,
      location: contact.location,
      phone: contact.phone,
      description: contact.description,
      protype: "R Contructions",
    };

    try {
      const resonse = await addData("enquiry/addenquiry", bodydata);
      const _data = resonse;
      console.log(_data);
      toast.success(_data.data.message);
      getAllSections();
      setcontact({
        name: "",
        location: "",
        email: "",
        phone: "",
        description: "",
      });
      handleClose();
    } catch (error) {
      if (error.resonse && error.resonse.data && error.resonse.data.message) {
        toast.error(error.resonse.data.message);
      } else {
        toast.error("An error occurred. Please try again.");
      }
    }
  };

  const [show, setShow] = useState(false);

  const handleShow = () => {
    setShow(true);
  };

  const handleClose = () => setShow(false);

  // testimialsos
  const testSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const testimonialData = [
    {
      name: "Mr. Gangan Reddy",
      image: "/assets/img/partners/gaganReddyt.png",
      pdfile: "/assets/img/partners/GanganReddy.pdf",
      rating: "★★★★★",
     date: "September 2024",
      feedback: `R Firms delivered my 5,000 sft commercial building on time with excellent quality and professionalism. Their transparent workflow, top-grade materials, and detailing impressed me. I highly recommend R Firms for any project.`,
    },

    {
      name: "Mr. Seshu Babu",
      date: "October 2023",
      image: "/assets/img/partners/Sletter.png",
      pdfile: "/assets/img/partners/SeshuBabu.pdf",
      rating: "★★★★★",
      feedback: `R Firms completed my 3,800 sft villa in Doyens Colony with quality, professionalism, and timely delivery. Their transparent process, skilled team, and attention to detail truly impressed me. I highly recommend R Firms.`,
    },
    {
      name: "Correspondent VHS",
     date: "March 2024",
      image: "/assets/img/partners/scholltestimoanls.jpg",
      pdfile: "/assets/img/partners/Correspondent.pdf",
      rating: "★★★★★",
      feedback: `R Firms delivered our 1,00,000 sft school block with top-quality construction, timely execution, and professionalism. Their transparent process, strong management, and client-first approach were truly commendable.`,
    },
  ];



  // prices
  const settings3 = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    autoPlay: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // STEPS
  const steps = [
    {
      number: "01",
      title: "Initial Consultation",
      image: "assets/img/all-images/about/initalconsulations.png",
      icon: "assets/img/all-images/about/Group 29.png",
      description: [
        "✓ Discuss client requirements and expectations.",
        "✓ Assess project feasibility and scope.",
        "✓ Identify potential challenges and solutions.",
      ],
    },
    {
      number: "02",
      title: "Planning and Design",
      image: "assets/img/all-images/about/Planninganddesgi.png",
      icon: "assets/img/all-images/about/hand-shake 1.png",
      description: [
        "✓ Create conceptual designs and layouts.",
        "✓ Finalize materials and specifications.",
        "✓ Ensure compliance with industry standards.",
      ],
    },
    {
      number: "03",
      title: "Budgeting and Approval",
      image: "assets/img/all-images/about/Budgetingandapprova.png",
      icon: "assets/img/all-images/about/budget.png",
      description: [
        "✓ Estimate costs and prepare a budget.",
        "✓ Get client approval on expenses.",
        "✓ Secure necessary permits and documentation.",
      ],
    },
    {
      number: "04",
      title: "Construction Begins",
      image: "assets/img/all-images/about/construction.jpg",
      icon: "assets/img/all-images/about/planning.png",
      description: [
        "✓ Begin on-site construction activities.",
        "✓ Monitor progress and ensure quality control.",
        "✓ Address any unforeseen issues.",
      ],
    },
    {
      number: "05",
      title: "Project Handover",
      image: "assets/img/all-images/about/Projecthandvover.png",
      icon: "assets/img/all-images/about/project.png",
      description: [
        "✓ Final inspection and quality check.",
        "✓ Client walkthrough and approval.",
        "✓ Handover project documentation and support.",
      ],
    },
  ];

  //   Partnerts
  const partnerLogos = [
    "assets/img/partners/pa5.png",
    "assets/img/partners/pa1.png",
    "assets/img/partners/pa2.png",
    "assets/img/partners/pa3.png",
    "assets/img/partners/pa4.png",
    "assets/img/partners/pa6.png",
  ];

  const setttings2 = {
    dots: false,
    infinite: true,
    speed: 1000,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 2 },
      },
    ],
  };

  return (
    <div style={{ overflowX: "hidden" }}>
      <Header />

      {/* Videooo */}
      <div className="video-container">
        {isLoading && <div className="loader">Loading...</div>}

        {/* {homeBanners && (
          <video
            src={imgUrl + homeBanners.video}
            autoPlay
            muted
            loop
            playsInline
            className="video-bg"
            preload="auto"
            onLoadedData={handleVideoLoad}
          />
        )} */}
        {homeBanners && (
          <video
            src="assets/img/logo/myBuiding.mp4"
            autoPlay
            muted
            loop
            playsInline
            className="video-bg"
            preload="auto"
            onLoadedData={handleVideoLoad}
          />
        )}

        {/* <div className="video-text">
          <div className="text-line text-white line">
            <h2>{homeBanners.titles}</h2>
            <p
              style={{
                overflow: "hidden",
                color: "white",
                textOverflow: "ellipsis",
              }}
              dangerouslySetInnerHTML={{
                __html: homeBanners.description,
              }}
            ></p>
          </div>
        </div> */}
        <div className="video-text">
          <h2
            className="text-line text-white line1"
            style={{ fontSize: "35px" }}
          >
            Welcome to R Firms
          </h2>
          <h2
            className="text-line text-white line2"
            style={{ fontSize: "35px" }}
          >
            Find Your Dream Property with R Firms
          </h2>
          <h2
            className="text-line text-white line3"
            style={{ fontSize: "35px" }}
          >
            Discover Prime Properties with R Firms
          </h2>
        </div>
      </div>

      {/* ABOUT SECITON */}
      <div
        style={{
          backgroundImage: "url(assets/img/all-images/about/background.png)",
          backgroundPosition: "right",
          backgroundRepeat: "no-repeat",
        }}
        className="about1-section-area mb-5 mt-4"
        id="aboutSection"
      >
        <div className="container">
          <div className="row align-items-center">
            <div
              style={{ backgroundColor: "#fff8eb" }}
              className="col-lg-6 faqmd d-lg-block d-none"
            >
              <div className="about-images-area">
                <div className="img1 text-center" data-aos="fade-right">
                  <img src={imgUrl + about.image} alt="housebox" />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-heading heading1">
                <h5 data-aos="fade-left">ABOUT OUR COMPANY</h5>
                <div className="space20" />
                <h2 className="text-anime-style-3">{about.title}</h2>
                <div className="space18" />
                <p
                  data-aos="fade-left"
                  dangerouslySetInnerHTML={{ __html: about.description }}
                />
                <div className="btn-area1 mt-3 ">
                  <a href="#price" className="seconbtn">
                    Discover More{" "}
                    <span className="arrow1">
                      <i
                        className="fa fa-long-arrow-right"
                        aria-hidden="true"
                      />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*TESTIMONIALS  */}
      {/* <div
        className="properties-section-area mt-5 mb-5 blog-grid-section-area"
        style={{
          backgroundImage: "url(assets/img/all-images/bg/bg1.png)",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto">
              <div className="property-heading heading1 text-center mb-4 mt-5">
                <b className="text-danger">Our Testimonials</b>
                <h2 className="text-anime-style-3">Reviews by our Customers</h2>
                <p className="mt-2">
                  Our commitment to quality construction and excellence is
                  reflected in the feedback from our clients. From residential
                  to commercial projects, we ensure durability, precision, and
                  customer satisfaction in every build.
                </p>
              </div>
            </div>
          </div>
          <Slider {...settings2}>
            {testimonals.map((testimonial, index) => (
              <div key={testimonial.id || index} className="px-2">
                <div className="blog-single-boxarea">
                  <div
                    className="img1"
                    style={{
                      width: "100%",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  >
                    <img src={imgUrl + testimonial.image} alt="image" />
                  </div>
                  <div className="content-area">
                    <ul className="videost">
                      <li>
                        <a
                          href={testimonial.youtubeUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i
                            style={{
                              fontSize: 22,
                              color: "#CB2026",
                              cursor: "pointer",
                            }}
                            className="fa fa-play p-2"
                            aria-hidden="true"
                          />
                        </a>
                      </li>
                    </ul>
                    <b style={{ color: "#CB2026" }}>{testimonial.name}</b>
                    <h6 style={{ fontSize: 14 }}>{testimonial.designation}</h6>
                    <p className="mt-2" style={{ fontSize: 14 }}>
                      {testimonial.description}
                    </p>
                    <div className="numberheight d-lg-block d-none">
                      <div className="number-outline">{`0${index + 1}`}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div> */}

      {/* PARTNERS */}
      <div
        className="our-clients py-4"
        id="partnerss"
        style={{ backgroundColor: "#f1f2f2" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="our-clients-box">
                <div className="col-lg-7 m-auto">
                  <div className="property-heading heading1 text-center">
                    <b className="text-danger">Our Clients</b>
                    <h2 className="text-anime-style-3">Our trusted partners</h2>
                    <p className="mt-2">
                      We collaborate with top tier, trusted partners to bring
                      you quality materials, reliable services, and timeless
                      designs ensuring your home gets nothing but the best.
                    </p>
                  </div>
                </div>
                <div className="our-client-slider mt-2">
                  <Slider {...setttings2}>
                    {partnerLogos.map((logo, index) => (
                      <div key={index} className="px-2">
                        <div className="client-logo border rounded shadow-sm">
                          <img src={logo} className="img-fluid" />
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="reviews" className="m-3">
        <div className="container">
          <div className="row section-row align-items-center">
            <div className="col-lg-12">
              <div className="section-title text-center">
                <h3 className="wow fadeInUp ">Client Reviews</h3>
                <div className="text-center">
                  <h2 className="underline-center">
                    Built with Precision & Integrity{" "}
                  </h2>
                </div>
                <p className="wow fadeInUp" data-wow-delay="0.2s">
                  Client feedback reflects our focus on strong, precise, and{" "}
                  <br />
                  satisfying construction for homes and businesses.
                </p>
              </div>
            </div>
          </div>
          <Slider {...testSettings}>
            {testimonialData.map((item, index) => (
              <div key={index} className="p-2">
                <div className="container">
                  <div className="row testimonial-card align-items-start bg-light p-3 shadow rounded">
                    <div className="col-md-2 text-center mb-3 mb-md-0">
                      <img
                        src={item.image || "default.jpg"}
                        alt={item.name}
                        className="img-fluid rounded-circle border border-2"
                        style={{
                          width: "60px",
                          height: "60px",
                          objectFit: "cover",
                          borderColor: "#f35",
                        }}
                      />
                    </div>
                    <div className="col-md-10">
                      <div className="d-flex align-items-center gap-2 flex-wrap">
                        <h5 className="mb-0">{item.name}</h5>
                        <div className="text-warning">
                          {[...Array(5)].map((_, i) => (
                            <i className="fa fa-star" key={i}></i>
                          ))}
                        </div>
                      </div>
                      <p
                        className=" mb-1"
                        style={{ fontSize: "14px" }}
                      >
                        {item.date || "October 27, 2025"}
                      </p>
                    </div>

                    <div className="col-md-12">
                      <p className="mb-0 font-16-regular">
                        {item.feedback}
                      </p>
                    </div>
                    <div className="text-center mt-3 testArrow">
                      <a
                        href={item.pdfile}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-danger fw-bold"
                      >
                        View More <i className="fa fa-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      {/*===== PRICING AREA STARTS =======*/}
      <div className="pricing-inner-section py-3" id="price">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 m-auto">
              <div className="property-heading heading1 text-center">
                <b className="text-danger">Pricing</b>
                <h2 className="text-anime-style-3">
                  Building Quality, Delivering Trust!
                </h2>
                <p className="mt-2">
                  Choose the right plan for your construction needs. From
                  affordable housing to premium luxury designs, we ensure
                  top-notch quality and timely delivery.
                </p>
              </div>
            </div>
          </div>
          <div className="row mb-4">
            <Slider {...settings3}>
              {plans.map((plan, index) => (
                <div key={index} className="p-2">
                  <div className="pricing-main-boxarea">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="price-area">
                          <div
                            className="d-flex justify-content-between p-4"
                            style={{ backgroundColor: "#ffbe33" }}
                          >
                            <h5>{plan.planType}</h5>
                            <h5 style={{ fontSize: "20px" }}>
                              ₹{plan.price}/sq.ft
                            </h5>
                          </div>
                          <div className="price-listarea">
                            <li
                              style={{ fontSize: "15px", color: "black" }}
                              className="mb-3"
                            >
                              {plan.description}
                            </li>
                            <b className="mt-3">Features</b>
                            <ul className="priceingUl">
                              {plan.features.map((feature, i) => (
                                <li key={i}>
                                  <i
                                    className="fa fa-long-arrow-right"
                                    aria-hidden="true"
                                  />{" "}
                                  {feature}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="btn-area1 text-center mb-4">
                        <button
                          className="seconbtn"
                          onClick={() => handleShow()}
                        >
                          Book Now{" "}
                          <span className="arrow1">
                            <i
                              className="fa fa-long-arrow-right"
                              aria-hidden="true"
                            />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>

      {/* FAQS */}
      <div
        className="about2-section-area py-5"
        id="faqss"
        style={{ backgroundColor: "#f1f2f2" }}
      >
        <div className="container">
          <div className="row mb-4">
            <div className="col-lg-8 m-auto">
              <div className="property-heading heading1 text-center">
                <b className="text-danger">FAQS</b>
                <h2 className="text-anime-style-3">
                  Need Help? We're Here for You!
                </h2>
                <p className="mt-2">
                  From stunning residential spaces to ambitious commercial and
                  industrial projects, we bring your vision to life with
                  expertise and precision.
                </p>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-5 faqmd">
              <div className="about-images-area">
                <div className="row align-items-center">
                  <div className="col-lg-6 col-md-6">
                    <div
                      className="img2"
                      data-aos="fade-left"
                      data-aos-duration={800}
                    >
                      <img
                        src="assets/img/all-images/about/about-img3.png"
                        alt="housebox"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div
                      className="img1"
                      data-aos="fade-left"
                      data-aos-duration={800}
                    >
                      <img
                        src="assets/img/all-images/about/about-img4.png"
                        alt="housebox"
                      />
                    </div>
                    <div className="space30" />
                    <div
                      className="img1"
                      data-aos="fade-left"
                      data-aos-duration={800}
                    >
                      <img
                        src="assets/img/all-images/about/about-img5.png"
                        alt="housebox"
                      />
                    </div>
                  </div>
                </div>
                <div className="author-img">
                  <img src="assets/img/logo/logo1.png" alt="housebox" />
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="about-heading heading1">
                <div className="accordion" id="accordionExample">
                  {faqs.map((item, index) => (
                    <div className="accordion-item" key={index}>
                      <h2 className="accordion-header">
                        <button
                          className={`accordion-button ${
                            openIndex === index ? "" : "collapsed"
                          }`}
                          type="button"
                          onClick={() => toggleFAQ(index)}
                          aria-expanded={openIndex === index ? "true" : "false"}
                          aria-controls={`faq-${item._id}`}
                        >
                          {item.question}
                        </button>
                      </h2>
                      <div
                        id={`faq-${item._id}`}
                        className={`accordion-collapse collapse ${
                          openIndex === index ? "show" : ""
                        }`}
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>{item.answer}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      <div className="container-fluid">
        <div className="row">
          {/* Left Side - Image */}
          <div className="col-sm-12 order-2 order-lg-1 col-lg-6 p-0 image-container">
            <img
              src={steps[activeStep].image}
              alt="step"
              className="img-fluid"
            />
          </div>

          {/* Right Side - Timeline */}
          <div className="col-sm-12 order-1 order-lg-2 col-lg-6 timeline d-flex flex-column justify-content-center">
            <div className="numberheight">
              <div className="number-outline1">{steps[activeStep].number}</div>
            </div>
            <p className="hrline"></p>
            <div className="d-flex">
              {steps.map((step, index) => (
                <div
                  key={index}
                  className={`step ${activeStep === index ? "active" : ""}`}
                  onClick={() => setActiveStep(index)}
                  style={{ cursor: "pointer" }}
                >
                  <img src={step.icon} alt={step.title} />
                  <p
                    style={{ fontSize: "12px", color: "black" }}
                    className="title d-lg-block d-none"
                  >
                    {step.title}
                  </p>
                </div>
              ))}
            </div>

            <div className="bottom-points">
              <ul id="step-description">
                {steps[activeStep].description.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* CONTAct us */}
      <div
        className="testimonial1-section-area"
        style={{
          backgroundImage: "url(assets/img/all-images/bg/bg1.png)",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
        id="contactSection"
      >
        <div className="container pt-5 pb-5">
          <div className="contact-inner-section">
            <div className="row">
              <div className="col-lg-5">
                <div className="contactcardst text-center">
                  <div className="mt-4">
                    <a href={`tel:${mediaIcons.phone}`}>
                      <img src="assets/img/all-images/cta/marketeq_call.png" />
                    </a>
                    <p style={{ color: "#CB2026" }} className="mt-2">
                      <strong>Call Support</strong>
                    </p>
                    <b>
                      <a
                        href={`tel:${mediaIcons.phone}`}
                        className="text-black"
                      >
                        +91{" "}
                        {mediaIcons.phone
                          ?.replace(/\D/g, "")
                          .slice(-10)
                          .replace(/(\d{3})(\d{3})(\d{4})/, "$1 $2 $3")}
                      </a>
                    </b>
                  </div>
                  <div className="mt-4">
                    <a href={`mailto:${mediaIcons.email}`}>
                      <img src="assets/img/all-images/cta/mail.png" />
                    </a>
                    <p style={{ color: "#CB2026" }} className="mt-2">
                      Write To Us
                    </p>
                    <b>
                      <a
                        href={`mailto:${mediaIcons.email}`}
                        className="text-black"
                      >
                        {mediaIcons.email}
                      </a>
                    </b>
                  </div>
                  <div className="mt-4">
                    <img
                      style={{ height: 230 }}
                      src="assets/img/all-images/cta/contact.png"
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="contact-form-area">
                  <b>CONTACT US</b>
                  <br />
                  <h4 className="mt-3" style={{ color: "#FFBE33" }}>
                    Schedule Your Free Consultation
                  </h4>
                  <p style={{ fontSize: 15 }}>
                    Experience top-quality construction services at unbeatable
                    rates. Let's bring your dream project to life!
                  </p>
                  <form onSubmit={(e) => handleSubmit(e)}>
                    <div className="row">
                      {/* Full Name */}
                      <div className="col-lg-6">
                        <div className="input-area">
                          <input
                            type="text"
                            placeholder="Full Name"
                            name="name"
                            value={contact.name}
                            required
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="input-area">
                          <input
                            type="email"
                            placeholder="Email Address"
                            value={contact.email}
                            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                            name="email"
                            required
                            onChange={(e) => handleChange(e)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="input-area">
                          <input
                            type="text"
                            placeholder="Phone Number"
                            minLength={10}
                            maxLength={10}
                            value={contact.phone}
                            required
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "" || /^[0-9\b]+$/.test(value)) {
                                if (value.length <= 10) {
                                  handleChange(e);
                                }
                              }
                            }}
                            name="phone"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="input-area">
                          <input
                            type="text"
                            placeholder="Location"
                            value={contact.location}
                            name="location"
                            onChange={(e) => handleChange(e)}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="input-area">
                          <textarea
                            placeholder="Description"
                            name="description"
                            value={contact.description}
                            onChange={(e) => handleChange(e)}
                            rows="4"
                            required
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="btn-area1 mt-3 text-center">
                          <button className="seconbtn" type="submit">
                            Book Now{" "}
                            <span className="arrow1">
                              <i
                                className="fa fa-long-arrow-right"
                                aria-hidden="true"
                              />
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Book a Plan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit(e);
              handleClose();
            }}
          >
            <div className="mb-3">
              <input
                type="text"
                className="input-name custom-input"
                placeholder="Full Name"
                value={contact.name}
                name="name"
                onChange={(e) => handleChange(e)}
                required
              />
            </div>
            <div className="mb-3">
              <input
                type="email"
                className="input-name custom-input"
                placeholder="Email"
                value={contact.email}
                name="email"
                onChange={(e) => handleChange(e)}
                required
              />
            </div>
            <div className="mb-3">
              <input
                type="text"
                className="input-name custom-input"
                placeholder="Phone Number"
                minLength={10}
                maxLength={10}
                value={contact.phone}
                required
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || /^[0-9\b]+$/.test(value)) {
                    if (value.length <= 10) {
                      handleChange(e);
                    }
                  }
                }}
                name="phone"
              />
            </div>
            <div className="mb-3">
              <input
                type="text"
                className="input-name custom-input"
                placeholder="Location"
                value={contact.location}
                name="location"
                onChange={(e) => handleChange(e)}
                required
              />
            </div>

            <Modal.Footer
              className="justify-content-center"
              style={{ border: "none" }}
            >
              <button className="seconbtn w-50" type="submit">
                Book Now{" "}
                <span className="arrow1">
                  <i className="fa fa-long-arrow-right" aria-hidden="true" />
                </span>
              </button>
            </Modal.Footer>
          </form>
        </Modal.Body>
      </Modal>

      <ToastContainer />
      <Footer />
    </div>
  );
};

export default Home;
